<template>
  <div class="dea-error">
    <i v-if="isIconVisible" class="dea-ico-error"></i>
    <p class="dea-heading--medium__xs dea-error__text">
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: "ErrorMessage",
  props: {
    isIconVisible: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

// #FIXME need to find a better solution to handle the two different error component

.dea-error {
  align-items: center;
  display: flex;
  margin-bottom: $space-x-small;
  margin-left: $space-base;
  margin-top: $space-base;

  .dea-ico-error {
    background-color: $dea-color-feedback-red-negative;
    border-radius: 50%;
    color: $dea-color-white;
    font-family: $font-primary-bold;
    font-size: $h-font-size-xx-small;
    margin-right: $space-x-small;
    padding: $space-xxx-small $space-xx-small;

    &::before {
      vertical-align: middle;
    }
  }

  p {
    color: $dea-color-feedback-red-negative;
    margin: 0;
  }
}
</style>
